var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _ from 'lodash';
import { INIT_ROOM_SETTINGS, SETTINGS_UPDATED, OPEN_MODAL_ADV, UN_MUTED_SET_VOLUME, UPDATE_VOLUME_STATE } from './actionTypes';
/**
 * Create an action for when the settings are updated.
 *
 * @param {Object} settings - The new (partial) settings properties.
 * @returns {{
 *     type: SETTINGS_UPDATED,
 *     settings: {
 *         audioOutputDeviceId: string,
 *         avatarURL: string,
 *         cameraDeviceId: string,
 *         displayName: string,
 *         email: string,
 *         localFlipX: boolean,
 *         micDeviceId: string,
 *         serverURL: string,
 *         soundsReactions: boolean,
 *         startAudioOnly: boolean,
 *         startWithAudioMuted: boolean,
 *         startWithVideoMuted: boolean,
 *         startWithReactionsMuted: boolean
 *     }
 * }}
 */
export function updateSettings(settings) {
    return {
        type: SETTINGS_UPDATED,
        settings
    };
}
export const addParticipantsUnPlugged = (id) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const participantsUnplugged = getState()['features/base/settings'].participantsUnplugged || [];
    dispatch(updateSettings({
        //@ts-ignore
        participantsUnplugged: _.uniq(participantsUnplugged.concat(id))
    }));
});
// eslint-disable-next-line require-jsdoc
export function updateVolumeState(vol) {
    return {
        type: UPDATE_VOLUME_STATE,
        vol
    };
}
export const initRoom = (roomSettings) => {
    return {
        type: INIT_ROOM_SETTINGS,
        roomSettings
    };
};
export const openAdvModal = (status) => {
    return {
        type: OPEN_MODAL_ADV,
        status
    };
};
export const handleUnMutedSetVolume = (status) => {
    return {
        type: UN_MUTED_SET_VOLUME,
        status
    };
};
